import { atom } from 'jotai';
import { ROUTES } from '../../../shared/constants/routes';

export const isEmbedAtom = atom(
  window.location?.pathname?.startsWith?.(ROUTES.EMBED.replace('/*', ''))
);
